import { z } from 'zod'

export const AddOrderInstructionSchema = z.object({
  orderInstruction: z.string(),
})

export type AddOrderInstructionSchemaInput = z.infer<typeof AddOrderInstructionSchema>
